"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAuthFlowProofs = void 0;
const internals_1 = require("aws-amplify/adapter-core/internals");
const adapter_core_1 = require("aws-amplify/adapter-core");
const createAuthFlowProofs = ({ customState, }) => {
    const codeVerifier = (0, adapter_core_1.generateCodeVerifier)(128);
    const randomState = (0, adapter_core_1.generateState)();
    const state = customState
        ? `${randomState}-${(0, internals_1.urlSafeEncode)(customState)}`
        : randomState;
    return { codeVerifier, state };
};
exports.createAuthFlowProofs = createAuthFlowProofs;
